var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import NativeAppBridgeClass from './classes/NativeAppBridgeClass';
import { isMobileApp } from './utils/NativeAppBridgeUtils';
/**
 * check if thanks app is present and ignoreMobileApp is false
 * @returns {boolean}
 */
export const isNativeApp = (request) => {
    return isMobileApp() && !request.ignoreMobileApp;
};
/**
 * function to get the native app headers
 * @param {request}
 */
export const getNativeAppHeaders = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const conf = {
        method: request === null || request === void 0 ? void 0 : request.method,
        url: request === null || request === void 0 ? void 0 : request.url,
        data: request === null || request === void 0 ? void 0 : request.data,
        params: request === null || request === void 0 ? void 0 : request.params,
    };
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.getSessionId();
    let appHeaders = yield NativeBridgeInstance.getHeaders(conf);
    return Object.assign(Object.assign({}, request === null || request === void 0 ? void 0 : request.headers), appHeaders);
});
/**
 * function to close thanks app web view
 */
export const closeWebView = () => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.close();
};
/**
 * function to show and hide thanks app tool bar
 * @param { boolean } viewToolBar
 */
export const showAppToolBar = (viewToolBar = false) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.showAppToolBar(viewToolBar);
};
/**
 * function to get logged in number
 * @returns {string}
 */
export const getLoggedInNumber = () => __awaiter(void 0, void 0, void 0, function* () {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    const analyticsParamsJson = yield NativeBridgeInstance.getAnalyticsParams();
    // logggedInNumber for android
    return ((analyticsParamsJson === null || analyticsParamsJson === void 0 ? void 0 : analyticsParamsJson.loggedInNumber) || (analyticsParamsJson === null || analyticsParamsJson === void 0 ? void 0 : analyticsParamsJson.logggedInNumber) || '');
});
/**
 * function to mark moengage event
 * @param eventName {string}
 * @param jsonBody {string}
 */
export const markMoEngageEvent = (eventName, jsonBody) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.markMoEngageEvent(eventName, jsonBody);
};
export const getAppVersion = () => __awaiter(void 0, void 0, void 0, function* () {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    const analyticsParamsJson = (yield NativeBridgeInstance.getAnalyticsParams()) || {};
    return {
        appVersion: analyticsParamsJson === null || analyticsParamsJson === void 0 ? void 0 : analyticsParamsJson.appVersion,
        appNumber: analyticsParamsJson === null || analyticsParamsJson === void 0 ? void 0 : analyticsParamsJson.appNumber,
    };
});
/**
 * function to invoke native barcode scanner
 * @param title {string}
 * @param validation { regex?: string, invalidValueError?: string, scanError?: string }
 * @param callback {any}
 */
export const getBarcode = (title, config, callback) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.getBarcode(title, config, callback);
};
/**
 * function to get callback on back press
 * @param callback {any}
 */
export const customBackPress = (callback) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    NativeBridgeInstance.customBackPress(callback);
};
/**
 * function to get analytics params
 */
export const getAnalyticsParams = () => __awaiter(void 0, void 0, void 0, function* () {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    const analyticsParamsJson = yield NativeBridgeInstance.getAnalyticsParams();
    return analyticsParamsJson;
});
/**
 * works only after user have visited app's profile page
 * @returns {string} user profile name
 */
export const getProfileName = () => __awaiter(void 0, void 0, void 0, function* () {
    const nativeBridgeInstance = new NativeAppBridgeClass();
    return yield nativeBridgeInstance.getProfileName();
});
/**
 * function to get location detials
 * @returns {object}
 */
export const fetchCurrentLocation = () => __awaiter(void 0, void 0, void 0, function* () {
    const nativeBridgeInstance = new NativeAppBridgeClass();
    return yield nativeBridgeInstance.fetchCurrentLocation();
});
/**
 * function to send branch analytics with Data
 * @param eventName {string}
 * @param jsonBody {any}
 */
export const sendBranchAnalytics = (eventName, eventData) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    let eventDataStr = '';
    if (eventData) {
        eventDataStr = JSON.stringify(eventData);
    }
    NativeBridgeInstance.sendBranchAnalytics(eventName, eventDataStr);
};
/**
 * to get call Status
 * error value object in case of failure
 * @returns Promise<{status, response}> object
 */
export const fetchCallStatus = (...args) => __awaiter(void 0, void 0, void 0, function* () {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    return NativeBridgeInstance.fetchCallStatus(...args);
});
export const requestPermission = (permission) => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    return NativeBridgeInstance.requestPermissionWebview(permission);
};
/**
 * to invoke bridge to autofill otp in webview
 */
export const readOtpWebview = () => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    return NativeBridgeInstance.readOtpWebview();
};
/**
 * to close otp gateway bridge
 * */
export const stopOtpListenerWebview = () => {
    const NativeBridgeInstance = new NativeAppBridgeClass();
    return NativeBridgeInstance.stopOtpListenerWebview();
};
/**
 * profile name will be fetched from digital api
 * @returns {string} user profile name
 */
export const getUserProfileName = () => __awaiter(void 0, void 0, void 0, function* () {
    const nativeBridgeInstance = new NativeAppBridgeClass();
    return yield nativeBridgeInstance.getUserProfileName();
});
